import { useMemo, useState } from "react";
import { countryProfiles, films } from "@/mocks/films";
import CountrySection from "@/pages/home/components/CountrySection";

export default function RegionSection() {
  const [active, setActive] = useState("all");

  const counts = useMemo(() => {
    const map: Record<string, number> = {};
    countryProfiles.forEach((c) => {
      map[c.key] = films.filter((f) => f.countryKey === c.key).length;
    });
    return map;
  }, []);

  const tabs = [{ key: "all", tabLabel: "全部" }, ...countryProfiles];
  const visible = countryProfiles.filter((c) => active === "all" || c.key === active);

  return (
    <section id="regions" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-20 max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs md:text-sm font-label tracking-[0.3em] text-primary-600 uppercase">Region Map</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">地域图谱</h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            同一套伦理追问，在不同国家会生长出不同的气质。选择下方地区，只看你关心的那一部分作品；
            切回「全部」则可以纵览整个欧洲的版图。
          </p>
        </div>

        <div className="mt-8 md:mt-10 sticky top-16 z-30 bg-background-50/95 backdrop-blur py-3">
          <div className="flex flex-wrap items-center justify-center gap-2">
            {tabs.map((tab) => {
              const isActive = active === tab.key;
              const count = tab.key === "all" ? films.length : counts[tab.key];
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActive(tab.key)}
                  aria-pressed={isActive}
                  className={`px-4 py-2 rounded-full text-sm border transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50 border-primary-500"
                      : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {tab.tabLabel}
                  <span className={`ml-1.5 text-xs ${isActive ? "text-background-50/80" : "text-foreground-400"}`}>
                    {count}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="mt-6">
        {visible.map((profile) => (
          <CountrySection
            key={profile.key}
            profile={profile}
            films={films.filter((f) => f.countryKey === profile.key)}
            index={countryProfiles.findIndex((c) => c.key === profile.key)}
          />
        ))}
      </div>
    </section>
  );
}